"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.defaultTextProps = exports.defaultAllowedProps = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utilities = require("@doordash/utilities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultAllowedProps = ['id', 'size', 'color', 'component', 'children'];
exports.defaultAllowedProps = defaultAllowedProps;
var defaultTextProps = {
  size: _propTypes.default.number,
  color: _propTypes.default.string,
  tag: _propTypes.default.string,
  children: _propTypes.default.node
};
exports.defaultTextProps = defaultTextProps;

var _default = function _default(BaseComponent) {
  var allowedProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultAllowedProps;
  var GeneratedComponent = (0, _utilities.withDynamicTag)(BaseComponent, allowedProps);
  GeneratedComponent.propTypes = defaultTextProps;
  return GeneratedComponent;
};

exports.default = _default;